import { useCallback } from 'react';
import { useSelector } from 'react-redux';
import { store } from 'redux/store';
import {
  selectMeteorologyFieldsModelPerformanceVariable,
  setFilter,
} from 'redux/reducers/meteorologyFieldsModelPerformanceReducer';

export default function useVariable() {
  const variable = useSelector(selectMeteorologyFieldsModelPerformanceVariable);

  const setVariable = useCallback((value: string | undefined) => {
    store.dispatch(setFilter({ variable: value }));
  }, []);

  return {
    variable,
    setVariable,
  };
}
